export default "__VITE_ASSET__obTgzTFg__"